<template>
  <div class="px-3" v-resize="onResize">
    <v-row class="px-3">
      <v-col cols="12" md="8" class="pl-0">
        <h1 class="py-md-3">
          {{ $t("viewGarage.title") }}
          <v-btn
            id="help-step-0"
            color="success"
            class="ml-1 green-shadow"
            elevation="0"
            x-small
            fab
            max-width="26"
            max-height="26"
            @click="garageDialog = true"
            :title="$t('common.add')"
            :disabled="!fetched"
            :loading="!fetched"
          >
            <v-icon x-small>$plus</v-icon>
          </v-btn>
        </h1>
      </v-col>
      <v-col cols="12" md="4" align-self="end" class="d-flex justify-end px-0">
        <v-text-field
          id="help-step-1"
          outlined
          :placeholder="$t('viewGarage.search_placeholder')"
          append-icon="fa-times"
          hide-details
          @click:append="search = ''"
          v-model="search"
          class="mb-2 text-field-bg d-none"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      ref="garageTable"
      :headers="garageCarsTableHeader"
      :items="filtedredAllCars"
      :height="tableHeight"
      class="elevation-0 mb-3"
      :loading="isLoadingTablesConfig"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:[lastHeaderElement]="props">
        {{ props.header.text }}
        <table-config-btn
          :table="tableName"
          :default-columns="defaultGarageCarsTableHeader"
        />
      </template>
      <template v-slot:item.brand="props">
        <div class="d-flex align-center">
          <div>
            <img
              align="center"
              class="brandLogoMiddle mr-3"
              v-if="!!brandURL(props.item.brand)"
              :src="brandURL(props.item.brand)"
              :title="props.item.brand.toUpperCase()"
            />
            <span
              class="brandWithoutLogo mr-3"
              :title="props.item.brand.toUpperCase()"
              v-else
            >
              {{ props.item.brand.toUpperCase().slice(0, 1) }}
            </span>
          </div>
          <div class="py-2">
            <span v-if="props.item.name && props.item.name!==''">{{props.item.name}}</span>
            <span v-else>
              {{ props.item.brand }} {{ props.item.family }} {{ props.item.model }}
            </span>
            <beauty-car-number
              :number="props.item.car_number ? props.item.car_number : ''"
            />
          </div>
        </div>
      </template>
      <template v-slot:item.image="props">
        <img
          align="center"
          :src="props.item.image ? props.item.image : $imgDummyPath"
          width="40px"
        />
      </template>
      <template v-slot:item.vin="props">
        {{ props.item.vin }}
      </template>
      <template v-slot:item.name="props">
        {{ props.item.name }}<br />
        <small
          v-if="
            props.item.brand +
              ' ' +
              props.item.family +
              ' ' +
              props.item.model !=
            props.item.name
          "
          ><i
            >{{ props.item.brand }} {{ props.item.family }}
            {{ props.item.model }}</i
          ></small
        >
      </template>
      <template v-slot:item.mileages[0].value="props">
        {{ props.item.mileages[0] ? props.item.mileages[0].value : "" }}
      </template>
      <template v-slot:item.customer.last_name="props">
        <span
          class="dashed"
          @click="
            customerId = props.item.customer.id;
            customerEditForm = true;
          "
        >
          {{ props.item.customer.last_name }}
          {{ props.item.customer.first_name }}
          {{ props.item.customer.patronymic }}
        </span>
        <span v-if="props.item.customer.phone.indexOf(search)">
          {{ [props.item.customer.phone] }}
        </span>
      </template>
      <template v-slot:item.actions="props">
        <div class="text-right" style="min-width: 280px">
          <span class="btn-td-wrap text-no-wrap">
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              class="mb-0 ml-3 px-0 white--text"
              color="success"
              :title="$t('common.creating_order')"
              :disabled="cartIsLoading"
              @click="goToSearchWithCustomerCar(props.item)"
            >
              <v-icon small>$cart</v-icon>
            </v-btn>
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              class="mb-0 ml-3 px-0 white--text"
              color="secondary"
              :title="$t('common.maintenance_parts')"
              :disabled="!props.item.maintenance_part_available"
              @click="
                $store.dispatch('garage/maintenanceParts', {
                  brand: props.item.brand,
                  link: props.item.levam_link,
                  car: props.item,
                });
                maintenancePartsForm = true;
              "
            >
              <v-icon small>$oils</v-icon>
            </v-btn>
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              class="mb-0 ml-3 px-0 white--text"
              color="secondary"
              title="OEM"
              :disabled="!props.item.levam_link || props.item.levam_link == -1 || props.item.levam_link.toString().length < 10"
              @click="toOEMWidget(props.item)"
            >
              <v-icon small>$oem</v-icon>
            </v-btn>
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              color="primary"
              class="mb-0 ml-3 px-0 white--text"
              @click="
                carEditForm.isVisible = true;
                carEditForm.carId = props.item.id;
                carFormTabsId = 0;
              "
              :title="$t('common.edit')"
            >
              <v-icon small>$pencil</v-icon>
            </v-btn>
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              @click="
                $store.dispatch('garage/carRemove', { id: props.item.id })
              "
              color="red lighten-2"
              class="mb-0 ml-3 px-0 white--text"
              :title="$t('common.remove')"
            >
              <v-icon small>$trash</v-icon>
            </v-btn>
          </span>
        </div>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <v-dialog v-model="carEditForm.isVisible" scrollable max-width="890">
      <carForm
        :show="carEditForm.isVisible"
        :car-id="carEditForm.carId"
        @removed="
          carEditForm.isVisible = false;
          this.$store.dispatch('garage/getGarage');
        "
        @store="
          () => {
            this.$store.dispatch('garage/getGarage');
            carEditForm.isVisible = false;
          }
        "
      ></carForm>
    </v-dialog>
    <v-dialog v-model="customerCreateForm" scrollable max-width="800px">
      <div class="customerCreateForm">
        <customerForm
          @removed="customerCreateForm = false"
          :is-visible="customerCreateForm"
          @store="
            (data) => {
              $store.dispatch('customers/get').then(() => {
                customer = data.new;
              });
              customerCreateForm = false;
            }
          "
        />
      </div>
    </v-dialog>
    <v-dialog
      v-model="garageDialog"
      scrollable
      max-width="890"
      max-height="90%"
      persistent
    >
      <v-card flat>
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("viewGarage.adding_car") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="garageDialog = !garageDialog">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="mt-2">
          <h3>{{ $t("common.customer") }}</h3>
          <template v-if="customer && customer.id">
            <strong>{{ customer.full_name }}</strong>
            <v-btn
              icon
              color="warning"
              @click="customer = { id: null }"
              class=""
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </template>
          <v-row align="center" class="mb-5" v-if="!customer || !customer.id">
            <v-col cols="8">
              <v-autocomplete
                outlined
                v-model="customer"
                :items="customers"
                clearable
                hide-no-data
                :item-text="
                  (item) => {
                    return item.first_name || item.last_name
                      ? (item.last_name || '') +
                          ' ' +
                          item.first_name +
                          ' ' +
                          (item.patronymic || '')
                      : null;
                  }
                "
                item-value="API"
                :label="$t('viewCustomers.search_exist_customer')"
                :placeholder="$t('common.start_typing_to_search')"
                prepend-inner-icon="mdi-database-search"
                return-object
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" class="text-left">
              <v-btn
                min-height="40"
                elevation="0"
                :loading="savingInProgress"
                color="primary"
                @click="customerCreateForm = true"
              >
                <v-icon small left>fa-user</v-icon>
                {{ $t("viewCustomers.add_customer") }}
              </v-btn></v-col
            >
          </v-row>
          <h3>{{ $t("common.car") }}</h3>
          <car-selector-by-api
            v-show="!tmpCar || !tmpCar.name"
            :visibility-status="garageDialog"
            @selected="(data) => selectCar(data)"
          />
          <template v-if="tmpCar">
            <strong v-if="tmpCar.name">
              <span v-if="tmpCar.name === ''">
                {{ tmpCar.brand }} {{ tmpCar.model }}</span
              >
              <span v-else> {{ tmpCar.name }}</span>
              <span v-if="tmpCar.vin"> VIN: {{ tmpCar.vin }}</span>
              <beauty-car-number
                class="d-inline-block ml-2"
                :number="tmpCar.car_number ? tmpCar.car_number : ''"
              />
              <v-btn icon color="warning" @click="tmpCar = {}" class="">
                <v-icon>fa-times</v-icon>
              </v-btn>
            </strong>
          </template>
        </v-card-text>
        <v-divider class=""></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            elevation="0"
            color="red"
            @click="garageDialog = false"
            :disabled="savingInProgress"
            :loading="savingInProgress"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            @click="store"
            :disabled="savingInProgress"
            :loading="savingInProgress"
          >
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="customerEditForm" scrollable max-width="890">
      <customerForm
        @removed="customerEditForm = false"
        :is-visible="customerEditForm"
        @store="
          (data) => {
            this.customerEditForm = false;
          }
        "
        :customer-id="customerId"
      ></customerForm>
    </v-dialog>
    <v-dialog v-model="maintenancePartsForm" scrollable max-width="90%">
      <maintenanceParts></maintenanceParts>
    </v-dialog>
  </div>
</template>
<script>
import CustomerGarage from "@/components/customer/CustomerGarage";
import { mapFields } from "vuex-map-fields";
import CustomerForm from "@/components/customer/CustomerForm.vue";
import MaintenanceParts from "@/components/garage/MaintenanceParts.vue";
import CarForm from "@/components/garage/CarForm.vue";
import BeautyCarNumber from "../../components/common/BeautyCarNumber";
import CommonMixin from "@/mixins/common";
import TableConfigBtn from "@/components/common/TableConfigBtn";
import CarSelectorByApi from "@/components/common/CarSelectorByApi";

export default {
  components: {
    CarSelectorByApi,
    TableConfigBtn,
    BeautyCarNumber,
    CustomerForm,
    CustomerGarage,
    CarForm,
    MaintenanceParts,
  },
  mixins: [CommonMixin],
  data: () => ({
    tableName: "garage",
    tableHeight: "100",
    customer: null,
    customerId: null,
    itemForMaintenanceSearch: null,
    customerEditForm: false,
    maintenancePartsForm: false,
    carEditForm: {
      isVisible: false,
      carId: null,
    },
    customerTypeFilter: null,
    search: "",
    garageDialog: false,
    customerCreateForm: false,
    tmpCar: null,
  }),
  mounted() {
    this.$store.dispatch("tables_config/get").then(() => {
      this.$store.dispatch("garage/getGarage");
      this.$store.dispatch("customers/get");
      this.$store.dispatch("customer_types/get");
      this.helpsteps = [
        {
          target: "#help-step-0",
          content: this.$t("viewGarage.help.add_new_car"),
        },
        {
          target: "#help-step-1",
          content: this.$t("viewGarage.help.search_car"),
        },
      ];
    });
  },
  watch: {
    garageDialog(to) {
      if (!to) {
        this.customer = null;
        this.tmpCar = null;
      }
    },
    fetched() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
  },
  methods: {
    store() {
      if (!this.customer || !this.customer.id) {
        this.$error(this.$t("viewCustomers.customer_is_empty"));
        return;
      }
      if (!this.tmpCar || !this.tmpCar.name) {
        this.$error(this.$t("windowFastOrder.error_no_car_selected"));
        return;
      }
      this.tmpCar.customer_id = this.customer.id
      this.$store
        .dispatch("garage/store", this.tmpCar)
        .then(() => {
          this.$store.dispatch("garage/getGarage");
        })
        .then(() => {
          this.garageDialog = false;
          //this.car = {};
          this.tmpCar = null;
          this.customer = null;
        });
    },
    selectCar(car) {
      if (!car.vin) {
        this.$error(this.$t("windowFastOrder.error_no_car_vin"));
        return;
      }
      if (!car.car_number) {
        this.$error(this.$t("windowFastOrder.error_no_car_number"));
        return;
      }
      this.tmpCar = car;
    },
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect =
        this.$refs["garageTable"] &&
        this.$refs["garageTable"].$el &&
        this.$refs["garageTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
  },
  computed: {
    ...mapFields("tables_config", ["tablesConfig", "isLoadingTablesConfig"]),
    ...mapFields("cart", ["cartIsLoading", "carts"]),
    ...mapFields("customers", ["customers", "fetched"]),
    ...mapFields("garage", [
      "garage",
      "fetched",
      "savingInProgress",
      "carFormTabsId",
      "car",
    ]),
    ...mapFields("customer_types", ["customerTypes"]),
    lastHeaderElement() {
      return (
        "header." +
        (this.garageCarsTableHeader.slice(-1) &&
          this.garageCarsTableHeader.slice(-1)[0] &&
          this.garageCarsTableHeader.slice(-1)[0].value)
      );
    },
    filtedredAllCars() {
      return this.garage.filter((item) => {
        if (!this.search.length) return true;
        let search = false;
        if (!item.customer.patronymic) item.customer.patronymic = "";
        if (!item.customer.first_name) item.customer.first_name = "";
        if (!item.customer.phone) item.customer.phone = "";
        if (!item.customer.car_number) item.customer.car_number = "";
        if (!item.customer.name) item.customer.name = "";
        if (!item.customer.vin) item.customer.vin = "";
        let res =
          item.customer.last_name
            .toUpperCase()
            .indexOf(this.search.toUpperCase()) != -1 ||
          item.customer.patronymic
            .toUpperCase()
            .indexOf(this.search.toUpperCase()) != -1 ||
          item.customer.first_name
            .toUpperCase()
            .indexOf(this.search.toUpperCase()) != -1 ||
          item.customer.phone.indexOf(this.search) != -1 ||
          (item.car_number ? item.car_number.toUpperCase() : "").indexOf(
            this.search.toUpperCase()
          ) != -1 ||
          (item.name ? item.name.toUpperCase() : "").indexOf(
            this.search.toUpperCase()
          ) != -1 ||
          (item.vin ? item.vin.toUpperCase() : "").indexOf(
            this.search.toUpperCase()
          ) != -1;
        return res;
      });
    },
    garageCarsTableHeader() {
      let tableHeaderConfig = this.getConfiguredTableHeader(
        this.tableName,
        this.defaultGarageCarsTableHeader
      );
      return tableHeaderConfig.filter((item) => item.is_hidden !== true);
    },
    defaultGarageCarsTableHeader() {
      return [
        {
          text: this.$t("common.car"),
          value: "brand",
          sortable: true,
          class: "text-no-wrap flex-nowrap justify-space-between",
        },
        {
          text: this.$t("common.picture"),
          value: "image",
          sortable: false,
          class: "px-0 mx-0 text-no-wrap flex-nowrap justify-space-between",
        },
        {
          text: this.$t("VIN"),
          value: "vin",
          sortable: true,
          class: "text-no-wrap flex-nowrap justify-space-between",
        },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap flex-nowrap justify-space-between",
        },
        {
          text: this.$t("common.mileage"),
          value: "mileages[0].value",
          sortable: true,
          class: "text-no-wrap flex-nowrap justify-space-between",
        },
        {
          text: this.$t("common.customer"),
          value: "customer.last_name",
          sortable: true,
          class: "text-no-wrap flex-nowrap justify-space-between",
        },
        {
          text: "",
          sortable: false,
          class: "text-no-wrap flex-nowrap justify-space-between",
          is_action_column: true,
          value: "actions",
        },
      ];
    },
  },
};
</script>

<style lang="css" scoped>
.brandLogoMiddle {
  width: 16px;
}

tr:hover .btn-td-wrap {
  display: block;
}

.btn-td-wrap {
  display: none;
}

</style>
